// @flow strict
import * as React from 'react'

import styles from './CustomerQuoteDiptych.module.scss'

import { SectionWrapper, SectionThemes } from '../../../SectionWrapper'

const ReadMoreChevron = () => (
  <span>
    <svg
      width="8"
      height="14"
      viewBox="0 0 10 18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M.293 16.293a1 1 0 001.414 1.414l8-8a1 1 0 000-1.414l-8-8A1 1 0 00.293 1.707L7.586 9 .293 16.293z"
        fill="#0ac1ff"
        fillRule="evenodd"
      />
    </svg>
  </span>
)

type CustomerQuoteDiptychProps = {|
  readMoreURL?: string,
  readMoreLabel?: string,
  sections: Array<{|
    quote: string,
    profile: {|
      name: string,
      avatarURL: string,
      industry?: string,
      location?: string,
      tagline?: string,
    |},
  |}>,
|}

const CustomerQuoteDiptych = ({
  sections,
  readMoreURL,
  readMoreLabel,
}: CustomerQuoteDiptychProps) => {
  if (
    sections.some(
      ({ profile: { industry, location, tagline } }) =>
        location == null || industry == null || tagline == null,
    )
  ) {
    return null
  }
  return (
    <SectionWrapper
      className={styles.sectionWrapper}
      theme={SectionThemes.DARK}
    >
      <div className={styles.root}>
        <div className={styles.quotesWrapper}>
          {sections.map(({ quote, profile }) => (
            <div className={styles.section} key={quote}>
              <blockquote>
                <h2 className={styles.quote}>{quote}</h2>
              </blockquote>
              <div className={styles.attribution}>
                <img
                  src={profile.avatarURL}
                  alt={profile.name}
                  className={styles.attributionAvatar}
                />
                <div className={styles.attributionWrapper}>
                  <p className={styles.attributionName}>{profile.name}</p>
                  <p className={styles.attributionInfo}>{profile.tagline}</p>
                  <p className={styles.attributionInfo}>
                    {profile.industry} <span aria-hidden="true">|</span>{' '}
                    {profile.location}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
        {readMoreLabel && readMoreURL && (
          <div className={styles.readMoreLink}>
            <a href={readMoreURL}>
              {readMoreLabel}
              <span className={styles.readMoreButton}>
                <ReadMoreChevron />
              </span>
            </a>
          </div>
        )}
      </div>
    </SectionWrapper>
  )
}

export default CustomerQuoteDiptych
